<template>
    <CardPage :section="4" :page="10" nextLabel="Save" :nextDisabled="nextDisabled">
        <comp-4-goals></comp-4-goals>
    </CardPage>
</template>

<script>
export default {
    methods: {
        nextDisabled() {
            return this.$store.get('section4/myGoalsInvalid');
        }
    }
};
</script>
